// Silver's COT page reads the CFTC disaggregated report's trader groups
// (DWLF-526). The fields are
// written by dwlf-scheduled-jobs fetchCotData: `${key}Net`, `${key}Index`
// (position of net in its trailing 156-week range, 0–100), `${key}NetChange`.
// The report starts 2006-06-13, so older weeks carry no group fields.

// Positioning extremes ("crowded"), Andy's DWLF-413 decision. Display only
// here: the platform's crowded claim for agents and reports is DWLF-527.
export const COT_UPPER = 90;
export const COT_LOWER = 10;

// `color` names a useSchemeColors key; `ink` is the neutral text colour.
// `highIs` is the contrarian read of a high index; null = no directional read.
export const COT_GROUPS = Object.freeze([
  {
    key: 'mm', label: 'Managed money', sub: 'funds and CTAs', color: 'warn', highIs: 'bearish',
    reading: 'high = funds crowded long (contrarian bearish)',
  },
  {
    key: 'prodMerc', label: 'Producers / merchants', sub: 'physical hedgers', color: 'accent', highIs: 'bullish',
    reading: 'high = hedgers least short (contrarian bullish)',
  },
  {
    key: 'swap', label: 'Swap dealers', sub: 'banks', color: 'ink', highIs: null,
    reading: 'dealers offsetting client swaps',
  },
]);

const isNil = (v) => v === null || v === undefined;

// The weeks the disaggregated report covers, oldest first.
export const disaggregatedWeeks = (series) => (Array.isArray(series) ? series.filter((row) => !isNil(row?.mmNet)) : []);

const READ_COLOR = Object.freeze({ bullish: 'success.main', bearish: 'error.main' });
const OPPOSITE = Object.freeze({ bullish: 'bearish', bearish: 'bullish' });

// MUI palette path for a group's index reading: an extreme takes the colour of
// that group's contrarian read; a group with no directional read stays neutral.
export const indexColor = (group, v) => {
  if (!COT_GROUPS.includes(group)) { throw new TypeError('indexColor: first argument must be a COT_GROUPS entry'); }
  if (isNil(v)) { return 'text.secondary'; }
  const { highIs } = group;
  if (highIs && v >= COT_UPPER) { return READ_COLOR[highIs]; }
  if (highIs && v <= COT_LOWER) { return READ_COLOR[OPPOSITE[highIs]]; }
  return 'text.primary';
};

// The API's asOf is the newest stored week of any report; a newer one than the
// page's newest disaggregated week means the disaggregated groups are behind.
export const disaggregatedLag = (apiAsOf, latestWeek) => (
  typeof apiAsOf === 'string' && latestWeek && apiAsOf.slice(0, 10) > latestWeek ? apiAsOf.slice(0, 10) : null
);
